const routes = [
  {
    path: 'aggridexport',
    name: 'aggridexport',
    component: () => import(/* webpackChunkName: "aggridexport" */ '@/modules/aggridexport/index.vue')
  },
];

export default routes;